import React, { useEffect, useState, ReactNode } from 'react';
import CTAAuthoredModal from 'components/CTAAuthoredModal/CTAAuthoredModal';
import { Button, Text, Box } from 'rebass';
import SignUpStudentBlock from 'components/SignUpStudentBlock';
import SignInBlock from 'components/SignInBlock';
import { User } from 'types/Users';
import css from './SignInUpModal.module.scss';
import { Link } from 'react-router-dom';
import { KEY_CONTENT_ROUTES } from 'routing';

const { TERMS, PRIVACY_POLICY } = KEY_CONTENT_ROUTES;

interface Props {
  visible?: boolean,
  footer?: ReactNode,
  loginHeader?: ReactNode,
  signUpHeader?: ReactNode,
  onCancel?: () => any,
  onSuccess: (user: User) => void | any,
}

export default function SignInUpModal(props: Props) {
  const {
    visible,
    loginHeader,
    signUpHeader,
    footer,
    onCancel,
    onSuccess,
  } = props;

  const [isSignUp, setIsSignUp] = useState(true);

  useEffect(() => {
    setIsSignUp(true);
  }, [visible]);

  const getFooter = (): React.ReactNode => {
    return isSignUp ? (
      <Text fontSize={2} color="text.grey">
        Already have an account?
        &nbsp;
        <Button
          variant="linkButton"
          onClick={() => setIsSignUp(false)}
        >
          Log In
        </Button>
      </Text>
    ) : (
      <Text fontSize={2} color="text.grey">
        New to Tutor House?
        &nbsp;
        <Button
          variant="linkButton"
          onClick={() => setIsSignUp(true)}
        >
          Sign Up
        </Button>
      </Text>
    );
  };

  return (
    <CTAAuthoredModal
      visible={visible}
      onCancel={onCancel}
      width="540px"
    >
      <Text variant="signIn.mainHeading" mb={2}>
        {isSignUp ? (signUpHeader || 'Sign Up to Continue') : (loginHeader || 'Sign In to Continue')}
      </Text>
      {isSignUp ? (
        <SignUpStudentBlock onSuccess={onSuccess} hideFooter hideTerms />
      ) : (
        <SignInBlock onSuccess={onSuccess} />
      )}
      {getFooter()}

      {isSignUp && <Box mb={4} className={css.termsAndConditions}>
        By signing up, you are agreeing to Tutor House’s
        &nbsp;
        <Link to={TERMS} target="_blank" className={css.termsLink}>
          Terms and Conditions
        </Link>
        &nbsp;
        and
        &nbsp;
        <Link to={PRIVACY_POLICY} target="_blank" className={css.termsLink}>
          Privacy Policy
        </Link>
        .
      </Box>}
      {footer}
    </CTAAuthoredModal>
  );
}
